export function twemojiUrl(emoji: string): string {
    return `https://cdnjs.cloudflare.com/ajax/libs/twemoji/15.0.3/svg/${emoji}.svg`;
}
